import React, {PropsWithChildren} from "react";

const CardSurface: React.FC<PropsWithChildren> = ({children}) => {
    return (
        <div className="blj-store-locator-card-surface">
            {children}
        </div>
    );
}

export default CardSurface;